module.exports = __webpack_public_path__ + "static/media/ProximaNovaLight.076d851b.otf";